import { caseStudyGridSection } from "~/content/sections/case-study-grid"
import { contactCtaSection } from "~/content/sections/contact-cta"
import { newsletterSection } from "~/content/sections/newsletter"
import { testimonialSection } from "~/content/sections/testimonial"

export const sectionIds = ["newsletter", "contact-cta", "testimonial", "case-study-grid"] as const

export const sections = {
  "newsletter": newsletterSection,
  "contact-cta": contactCtaSection,
  "testimonial": testimonialSection,
  "case-study-grid": caseStudyGridSection,
}
